module.exports = __webpack_public_path__ + "static/media/yu.f19a2b98.png";